module.exports = __webpack_public_path__ + "static/img/Saipa_banner2_Far.2c65152.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Saipa_banner2_Far.png
// module id = 15
// module chunks = 1